<script setup>
import { computed } from 'vue';
import { CORES_STATUS_PAGAMENTO, ICONES_STATUS_PAGAMENTO } from '@/commons/projetos';

const props = defineProps({
    valor: String,
});

const cor = computed(() => CORES_STATUS_PAGAMENTO[props.valor] ?? 'cinza');
const icone = computed(() => ICONES_STATUS_PAGAMENTO[props.valor]);
</script>

<template>
    <TagBase :valor="valor" :cor="cor" :icone="icone" />
</template>
